import { useCallback } from "react";

const useWsTaskSelectionHandler = ({
  setOriginalTaskList,
  setUserSelection,
  setShowTaskButton,
  setTaskSelectionDialog,
  taskSelectionDialog,
}) => {
  return useCallback((data) => {
    if (data.type !== "task_selection_request") return false;

    console.log("收到任务选择请求:", data);
    let taskData;
    try {
      taskData = typeof data.data === "string" ? JSON.parse(data.data) : data.data;
    } catch (error) {
      console.error("解析任务选择数据失败:", error);
      taskData = data.data || {};
    }

    const isRestore = taskData.is_restore || false;
    const isDialogOpen = taskSelectionDialog.open;

    if (isRestore) {
      console.log("恢复模式：设置原始列表和用户选择");
      setOriginalTaskList({
        software: taskData.original_software_list || [],
        hardware: taskData.original_hardware_list || [],
      });
      setUserSelection({
        software: taskData.current_software_selection || [],
        hardware: taskData.current_hardware_selection || [],
      });
      setShowTaskButton(true);

      if (!isDialogOpen) {
        setTaskSelectionDialog({
          open: true,
          isRestore: true,
          isUserModification: false,
          updateId: Date.now(),
        });
      } else {
        setTaskSelectionDialog((prev) => ({
          ...prev,
          updateId: Date.now(),
        }));
      }
      return true;
    }

    console.log("首次模式：初始化原始列表，默认不选中任何模块");
    const originalSW = taskData.software_tasks || [];
    const originalHW = taskData.hardware_tasks || [];

    setOriginalTaskList({
      software: originalSW,
      hardware: originalHW,
    });
    setUserSelection({
      software: [],
      hardware: [],
    });
    setShowTaskButton(true);
    setTaskSelectionDialog({
      open: true,
      isRestore: false,
      isUserModification: false,
      updateId: Date.now(),
    });
    return true;
  }, [
    setOriginalTaskList,
    setShowTaskButton,
    setTaskSelectionDialog,
    setUserSelection,
    taskSelectionDialog.open,
  ]);
};

export default useWsTaskSelectionHandler;
